"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/function-component-definition */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/alt-text */
const react_1 = __importStar(require("react"));
const isEmail_1 = __importDefault(require("~/utils/isEmail"));
const assets_1 = require("~/assets");
const types_1 = require("~/store/types");
const EmailInput_scss_1 = __importDefault(require("./EmailInput.scss"));
const EmailInput = ({ inputKey, state: { error, value }, onInput, onError, placeholder = '', required = false, maxlength = Infinity, }) => {
    const [focused, setFocused] = (0, react_1.useState)(false);
    const [validate, setValidate] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!focused && validate && required) {
            if (!value || value.trim().length === 0) {
                onError(inputKey, types_1.INPUT_ERRORS.required);
                return;
            }
            if (!(0, isEmail_1.default)(value)) {
                onError(inputKey, types_1.INPUT_ERRORS.invalid);
                return;
            }
        }
        onError(inputKey, types_1.INPUT_ERRORS.none);
    }, [focused, validate, required, value]);
    const changeHandler = (e) => {
        onInput(inputKey, e.target.value);
    };
    const focusHandler = () => {
        setFocused(true);
        setValidate(true);
    };
    const blurHandler = () => setFocused(false);
    return (react_1.default.createElement("div", { className: `${EmailInput_scss_1.default.container} ${error ? EmailInput_scss_1.default.error : ''}` },
        react_1.default.createElement("input", { className: EmailInput_scss_1.default.input, type: "text", value: value, onChange: changeHandler, maxLength: maxlength, placeholder: placeholder, onFocus: focusHandler, onBlur: blurHandler }),
        error ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: EmailInput_scss_1.default.icon },
                react_1.default.createElement("img", { src: assets_1.svgSystemError })),
            react_1.default.createElement("div", { className: EmailInput_scss_1.default.error }, error))) : null));
};
exports.default = EmailInput;
